import type { DefaultOptionType } from 'antd/es/select';

import type { ProductClassListApi } from '../../../models';

export const normalizeShipmentProductClassOptions = (list: ProductClassListApi): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((item) => ({
    label: item.codeDesc,
    value: item.codeId,
  }));
};
